import { render, staticRenderFns } from "./FullModal.vue?vue&type=template&id=48e1c7c4&"
import script from "./FullModal.vue?vue&type=script&lang=js&"
export * from "./FullModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports